import React from 'react';
import { MapPin } from 'lucide-react';
const CITIES = ['Gilbert', 'Chandler', 'Mesa', 'Queen Creek', 'Tempe', 'San Tan Valley', 'Ahwatukee', 'Scottsdale'];
export function ServiceArea() {
  return <section id="service-area" className="w-full bg-background py-20 lg:py-28" data-id="element-150" data-mp="s1vddkkal7mj">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-151" data-mp="na3iwyy0mhr4">
        <span className="font-display text-lg tracking-wide text-accent" data-id="element-152" data-mp="11yzsj0fq02tu">Where We Work</span>
        <h2 className="mt-2 font-display text-4xl leading-tight text-foreground sm:text-5xl" data-id="element-153" data-mp="x057drua626k">
          Proudly Serving the East Valley
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground" data-id="element-154" data-mp="1aymqtdd5ksio">
          Based in Gilbert, Arizona — we bring professional landscape lighting to homes
          across the greater Phoenix metro.
        </p>

        <div className="mx-auto mt-10 flex max-w-4xl flex-wrap justify-center gap-3" data-id="element-155" data-mp="3ctdnyhu2lt8g">
          {CITIES.map(city => <span key={city} className="flex items-center gap-2 rounded-full border border-border bg-card px-5 py-2.5 text-foreground" data-id="element-156" data-mp="1a7yozxw981rr">
              <MapPin className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-157" data-mp="1f4yv28t3t4iv" />
              <span className="font-semibold" data-id="element-158" data-mp="1k4jsufwjf6u0">{city}</span>
            </span>)}
        </div>
      </div>
    </section>;
}